"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var SoulModule = require('./SoulModule');

var config = require('../config');

var validation = require('../services/validation');
/**
* Create albums, upload photos
* @extends SoulModule
*/


var Media =
/*#__PURE__*/
function (_SoulModule) {
  _inherits(Media, _SoulModule);

  function Media() {
    _classCallCheck(this, Media);

    return _possibleConstructorReturn(this, _getPrototypeOf(Media).apply(this, arguments));
  }

  _createClass(Media, [{
    key: "getAlbums",

    /**
    * getAlbums
    * @param {Object} [params]
    * @param {Object} [params.userId] if not set, get current user's albums
    * @param {Object} params.parameters
    * @param {Number} params.parameters.offset Specifies how many results to skip for the first returned result
    * @param {Number} params.parameters.limit Specifies how many results to return
    * @param {function} [callback]
    * @return {Promise}
    * @soulsdk soul.media.getAlbums
    * @example soul.media.getAlbums({
    *   userId: 5c362062ad8e7e67be1359ed,
    *   parameters: {
    *     offset: 10,
    *     limit: 10
    *   }
    * })
    */
    value: function getAlbums() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;

      if (params.userId) {
        return this.api.get("users/".concat(params.userId, "/albums"), params.parameters, callback);
      }

      return this.api.get('me/albums', params.parameters, callback);
    } // sugar gerAllUserAlbums

    /**
    * createAlbum
    * @param {Object} params
    * @param {Number} params.name
    * album name
    * @param {String} [params.privacy]
    * The privacy level of an album. One of "private", "public", "unlisted"
    * @default "public"
    * @param {Number} [params.order]
    * Position of the album in the album list
    * @param {Number} [params.expiresTime]
    * Expiration time of the album (unixtimestamp)
    * @param {Object} [params.parameters]
    * Schemaless dictionary with album parameters
    * @param {function} [callback]
    * @return {Promise}
    * @soulsdk soul.media.createAlbum
    * @example soul.media.createAlbum({
    *   privacy: 'public',
    *   name: 'my album',
    *   order: 1,
    *   expiresTime: 1558336.335
    * })
    *
    */

  }, {
    key: "createAlbum",
    value: function createAlbum(params, callback) {
      if (!validation.albumName(params.name)) {
        var nameValidationError = new Error('invalid album name\n' + 'valid album name may contain only alphabetic characters, digits, hyphen and underscore (A-Z, a-z, 0-9, -, _)');

        if (callback) {
          callback(nameValidationError);
        }

        return Promise.reject(nameValidationError);
      }

      params.privacy = params.privacy || config.defaultAlbumPrivacy;
      return this.api.post(function (res) {
        return res.album;
      }, 'me/albums', params, callback);
    }
    /**
    * getAlbum
    * @param {Object} params
    * @param {String} params.albumName album name
    * @param {String} params.source image sources
    * @param {Object} [params.userId] if not set, get current user's album
    * @param {function} [callback]
    * @return {Promise}
    * @soulsdk soul.media.getAlbum
    * @example soul.media.getAlbum({
    *   albumName: 'my album',
    * })
    */

  }, {
    key: "getAlbum",
    value: function getAlbum(_ref, callback) {
      var userId = _ref.userId,
          albumName = _ref.albumName,
          source = _ref.source;

      if (userId) {
        return this.api.get(function (res) {
          return res.album;
        }, "users/".concat(userId, "/albums/").concat(albumName).concat(source ? "?source=".concat(source) : ''), callback);
      }

      return this.api.get(function (res) {
        return res.album;
      }, "me/albums/".concat(albumName).concat(source ? "?source=".concat(source) : ''), callback);
    }
    /**
    * updateAlbum
    * @param {Object} params
    * @param {Number} params.name album name
    * @param {Object} params.parameters
    * @param {String} [params.parameters.privacy]
    * may be "public", "private" or "unlisted"
    * @param {Number} [params.parameters.order]
    * Position of the album in the album list
    * @param {Number} [params.parameters.expiresTime]
    * Expiration time of the album (unixtimestamp)
    * @param {Object} [params.parameters.parameters]
    * Schemaless dictionary with album parameters
    * @param {function} [callback]
    * @return {Promise}
    * @soulsdk soul.media.updateAlbum
    * @example soul.media.updateAlbum({
    *   privacy: 'private',
    *   name: 'new album name',
    *   order: 2,
    *   expiresTime: 1557336.335
    * })
    */

  }, {
    key: "updateAlbum",
    value: function updateAlbum(_ref2, callback) {
      var albumName = _ref2.albumName,
          album = _ref2.album;
      return this.api.patch(function (res) {
        return res.album;
      }, "me/albums/".concat(albumName), album, callback);
    }
    /**
    * deleteAlbums
    * @param {Object} params
    * @param {String} params.name album name
    * @param {function} [callback]
    * @return {Promise}
    * @soulsdk soul.media.deleteAlbum
    * @example soul.media.deleteAlbum()
    */

  }, {
    key: "deleteAlbum",
    value: function deleteAlbum(_ref3, callback) {
      var albumName = _ref3.albumName;
      return this.api["delete"]("me/albums/".concat(albumName), callback);
    }
    /**
    * uploadPhoto
    * @param {Object} [params]
    * @param {String} params.albumName
    * @default 'default'
    * @param {File} params.photo Photo file
    * @param {function} [callback]
    * @return {Promise}
    * @soulsdk soul.media.uploadPhoto
    * @example soul.media.uploadPhoto({
    *   albumName: 'my album',
    *   photo: new File()
    * })
    */

  }, {
    key: "uploadPhoto",
    value: function uploadPhoto(_ref4, callback) {
      var _ref4$albumName = _ref4.albumName,
          albumName = _ref4$albumName === void 0 ? config.defaultAlbumName : _ref4$albumName,
          photo = _ref4.photo,
          _ref4$source = _ref4.source,
          source = _ref4$source === void 0 ? 'unknown' : _ref4$source;
      return this.api.post(function (res) {
        return res.photo;
      }, "me/albums/".concat(albumName), [{
        name: 'photo',
        photo: photo
      }], callback);
    }
  }, {
    key: "uploadAudioToChat",
    value: function uploadAudioToChat(file, duration, hash, chatId, myId, callback) {
      return this.api.post(function (res) {
        return res.audio;
      }, 'me/audio', [{
        hash: hash,
        duration: duration,
        src: file,
        type: 'audio',
        chat_id: chatId,
        user_id: myId
      }], callback);
    }
  }, {
    key: "getAudio",
    value: function getAudio(_ref5, callback) {
      var userId = _ref5.userId,
          audioId = _ref5.audioId;

      if (userId) {
        return this.api.get(function (res) {
          return res.audio;
        }, "users/".concat(userId, "/audio/").concat(audioId), callback);
      }

      return this.api.get(function (res) {
        return res.audio;
      }, "me/audio/".concat(audioId), callback);
    }
    /**
    * getPhoto
    * @param {Object} [params]
    * @param {String} params.albumName
    * @default 'default'
    * @param {String} params.photoId
    * @param {function} [callback]
    * @return {Promise}
    * @soulsdk soul.media.getPhoto
    * @example soul.media.getPhoto({
    *   albumName: 'my album',
    *   photoId: '26d6a3a5-417c-40e9-b74f-3ddb6bf3ff70'
    * })
    */

  }, {
    key: "getPhoto",
    value: function getPhoto(_ref6, callback) {
      var userId = _ref6.userId,
          _ref6$albumName = _ref6.albumName,
          albumName = _ref6$albumName === void 0 ? config.defaultAlbumName : _ref6$albumName,
          photoId = _ref6.photoId;

      if (userId) {
        return this.api.get(function (res) {
          return res.photo;
        }, "users/".concat(userId, "/albums/").concat(albumName, "/").concat(photoId), callback);
      }

      return this.api.get(function (res) {
        return res.photo;
      }, "me/albums/".concat(albumName, "/").concat(photoId), callback);
    }
    /**
    * updatePhoto
    * @param {Object} [params]
    * @param {String} params.albumName
    * @default 'default'
    * @param {String} params.photoId
    * @param {Object} params.parameters
    * @param {Number(Int)} [params.parameters.order]
    * Position of the photo in the list
    * @param {Boolean} [params.parameters.mainPhoto]
    * if true, sets this photo as main for the current album
    * @param {Number(float)}
    * [params.parameters.expiresTime] Time when photo expires, unixtimestamp
    * @param {String} [params.parameters.albumName]
    * If set, attaches photo to specified album
    * @param {function} [callback]
    * @return {Promise}
    * @soulsdk soul.media.updatePhoto
    * @example soul.media.updatePhoto({
    *   photoId: '26d6a3a5-417c-40e9-b74f-3ddb6bf3ff70',
    *   parameters: {
    *     order: 1,
    *     mainPhoto: false,
    *     expiresTime: 1557336.335
    *   }
    * })
    */

  }, {
    key: "updatePhoto",
    value: function updatePhoto(_ref7, callback) {
      var _ref7$albumName = _ref7.albumName,
          albumName = _ref7$albumName === void 0 ? config.defaultAlbumName : _ref7$albumName,
          photoId = _ref7.photoId,
          photo = _ref7.photo;
      return this.api.patch(function (res) {
        return res.photo;
      }, "me/albums/".concat(albumName, "/").concat(photoId), photo, callback);
    }
    /**
    * deletePhoto
    * @param {Object} [params]
    * @param {String} params.albumName
    * @default 'default'
    * @param {String} params.photoId
    * @param {function} [callback]
    * @return {Promise}
    * @soulsdk soul.media.deletePhoto
    * @example soul.media.deletePhoto({
    *   photoId: '26d6a3a5-417c-40e9-b74f-3ddb6bf3ff70',
    *   albumName: 'my album',
    * })
    */

  }, {
    key: "deletePhoto",
    value: function deletePhoto(_ref8, callback) {
      var _ref8$albumName = _ref8.albumName,
          albumName = _ref8$albumName === void 0 ? config.defaultAlbumName : _ref8$albumName,
          photoId = _ref8.photoId;
      return this.api["delete"]("me/albums/".concat(albumName, "/").concat(photoId), callback);
    }
    /**
    * set main album photo
    * @param {Object} [params]
    * @param {String} params.albumName
    * @default 'default'
    * @param {String} params.photoId
    * @param {function} [callback]
    * @return {Promise}
    * @soulsdk soul.media.setAlbumMainPhoto
    * @example soul.media.setAlbumMainPhoto({
    *   photoId: '26d6a3a5-417c-40e9-b74f-3ddb6bf3ff70',
    *   albumName: 'my album',
    * })
    */

  }, {
    key: "setAlbumMainPhoto",
    value: function setAlbumMainPhoto(params, callback) {
      params.photo = {
        mainPhoto: true
      };
      return this.updatePhoto(params, callback);
    }
  }, {
    key: "grantPartnerPermissionsToPhoto",
    value: function grantPartnerPermissionsToPhoto(photoId, partnerId, callback) {
      return this.api.post("me/albums/profile/".concat(photoId, "/permission"), {
        user: partnerId
      }, callback);
    }
  }, {
    key: "setImageSource",
    value: function setImageSource(photoId, source) {
      return this.api.patch("me/albums/profile/".concat(photoId), {
        source: source
      });
    }
  }, {
    key: "setAnnouncementPhoto",
    value: function setAnnouncementPhoto(photo) {
      return this.api.post('announcements/first/photos/', [{
        name: 'file',
        photo: photo
      }]);
    }
  }, {
    key: "deletePhotoNew",
    value: function deletePhotoNew(photoId) {
      return this.api["delete"]("announcements/first/photos/".concat(photoId, "/"));
    }
    /**
    * getUserVideo
    * @param {Object} [params]
    * @param {String} params.userId
    * @param {String} params.videoId
    * @soulsdk soul.media.getUserVideo
    * @example soul.media.getUserVideo({
    *   userId: '637ce7d6058a8c790d7636e9',
    *   videoId: '637ce7d6058a8c790d7636e9'
    * })
    */

  }, {
    key: "getUserVideo",
    value: function getUserVideo(_ref9) {
      var userId = _ref9.userId,
          videoId = _ref9.videoId;
      return this.api.get("users/".concat(userId, "/video/").concat(videoId, "/"));
    }
    /**
    * getMeVideo
    * @param {Object} [params]
    * @param {String} params.userId
    * @param {String} params.videoId
    * @soulsdk soul.media.getUserVideo
    * @example soul.media.getUserVideo({
    *   videoId: '637ce7d6058a8c790d7636e9'
    * })
    */

  }, {
    key: "getMeVideo",
    value: function getMeVideo(_ref10) {
      var videoId = _ref10.videoId;
      return this.api.get("me/video/".concat(videoId, "/"));
    }
    /**
    * getPrivateMedia
    * @param {String} url
    * @soulsdk soul.media.getPrivateMedia
    * @example soul.media.getPrivateMedia(
    *   https://example.com/private/image.jpeg
    * )
    */

  }, {
    key: "getPrivateMedia",
    value: function () {
      var _getPrivateMedia = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(url) {
        var accessToken;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                accessToken = this.storage.get('accessToken');
                _context.next = 3;
                return fetch(url, {
                  headers: {
                    Authorization: "Bearer ".concat(accessToken)
                  }
                });

              case 3:
                return _context.abrupt("return", _context.sent);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getPrivateMedia(_x) {
        return _getPrivateMedia.apply(this, arguments);
      }

      return getPrivateMedia;
    }()
  }]);

  return Media;
}(SoulModule);

module.exports = Media;